class ImageGallery {
    constructor() {
        this.addListeners()
    }

    addListeners() {
        const galleries = document.querySelectorAll('.image-gallery')

        if (galleries) {
            galleries.forEach(gallery => {
                this.addGallery(gallery)
            })
        }
    }

    addGallery(gallery) {
        const buttons = gallery.querySelectorAll('.image-gallery__control');

        buttons.forEach(button => {
            button.addEventListener('click', (e) => {

                this.changeImage(gallery, buttons, +e.target.dataset.id)
            })
        })
    }

    changeImage(gallery, buttons, id) {
        const images = gallery.querySelectorAll('.image-gallery__image');

        console.log(buttons);

        images.forEach(image => {
            if (+image.dataset.id == id) {
           //     console.log('X' + image.dataset.id)
                image.classList.add('image-gallery__image--active')
            } else {
             //   console.log('Y' + image.dataset.id)
                image.classList.remove('image-gallery__image--active')
            }
        })
        buttons.forEach(button => {
            if (+button.dataset.id == id) {
             //   console.log('D' + button.dataset.id)
                button.classList.add('image-gallery__control--active')
            } else {
              //  console.log('F' + button.dataset.id)
                button.classList.remove('image-gallery__control--active')
            }
        })
    }
} 

export default ImageGallery